import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";


import { environment } from "environments/environment";
import { Offer, OfferComponent } from "./offers-state/offers.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class OffersService {
  private _apiUrl = environment.apiUrl;
  private _httpClient = inject(HttpClient);

  getOffers() {
    return this._httpClient.get<Offer[]>(`${this._apiUrl}/v1/offers/get-all-offers`);
  }

  getNewOfferNumber() {
    return this._httpClient.get<{ offerNumber: string; }>(`${this._apiUrl}/v1/offers/get-new-offer-number`);
  }

  getOfferById(id: string) {
    return this._httpClient.get<Offer>(`${this._apiUrl}/v1/offers/get-offer-by-id/${id}`);
  }

  createOffer(payload: any) {
    return this._httpClient.post<any>(`${this._apiUrl}/v1/offers/create-offer`, payload);
  }

  updateOffer(id: string, payload: Offer, md5Checksum: string) {
    return this._httpClient.put<Offer>(
      `${this._apiUrl}/v1/offers/update-offer/${id}/${md5Checksum}`,
      payload
    );
  }

  deleteOffer(id: string) {
    return this._httpClient.delete<void>(`${this._apiUrl}/v1/offers/delete-offer/${id}`);
  }


  getOfferCustomers() {
    const url = `${this._apiUrl}/v1/stakeholders/get-stakeholders/Customers`;
    return this._httpClient.get<{ _id: string; name: string; }[]>(url);
  }

  getOfferTerms(stakeholderId: string) {
    const payload = { type: 'offerTerms', stakeholders: [stakeholderId] };
    return this._httpClient.post(`${this._apiUrl}/v1/templates/get-template-form-values`, payload);
  }

  createPdf(id: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/offers/pdf-offer/${id}`,
      { responseType: 'blob' }
    );
  }

  getDropdownsFilter(payload) {
    return this._httpClient.post(`${this._apiUrl}/v1/dropdown-options/get-dropdowns-filter`, payload);
  }

  updateOfferStatus(id: string, payload: string) {
    return this._httpClient.put(`${this._apiUrl}/v1/offers/update-offer-status/${id}`, payload);
  }

  removeOfferComponent(offerComponentId: string) {
    return this._httpClient.delete<void>(`${this._apiUrl}/v1/offers/delete-offer-component/${offerComponentId}`);
  }

  getTobaccoTypes(): Observable<{ id: string; value: string; }[]> {
    return this._httpClient.get<{ id: string; value: string; }[]>(
      `${this._apiUrl}/v1/dropdown-options/get-by-type?type=tobaccoForm`
    );
  }

  getTobaccoType(): Observable<{ id: string; value: string; }[]> {
    return this._httpClient.get<{ id: string; value: string; }[]>(
      `${this._apiUrl}/v1/dropdown-options/get-by-type?type=tobaccoType`
    );
  }

  getOfferComponentsById(id: string) {
    return this._httpClient.get<OfferComponent[]>(`${this._apiUrl}/v1/offers/get-offer-components-by-id/${id}`);
  }

  getOfferOrigins(): Observable<{ id: string; value: string; }[]> {
    return this._httpClient.get<{ id: string; value: string; }[]>(
      `${this._apiUrl}/v1/dropdown-options/get-by-type?type=offerOrigins`
    );
  }

  exportOffers() {
    return this._httpClient.get(`${this._apiUrl}/v1/offers/export-offers`, {
      responseType: "blob",
      observe: "response",
    });
  }

}
